import { styled } from '@mui/material';

export const OperationsSubmit = styled('div')({
  width: 450,
  padding: 20,
  '& .title': {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: '30px',
    letterSpacing: '0.15px',
    color: '#000000',
    marginBottom: 10,
  },

  '& .description': {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#000000',
    marginBottom: 20,
  },

  '& .count': {
    color: '#6868FE',
  },

  '& .actions': {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    '& button': {
      borderRadius: 5,
      marginBottom: 7,
    },
  },
});
